import { EndCustomersService, GradeServices, HLpercentagesService, LocationsService, PackingMethodService, PalletService, ProductService, RackEndCustomerMapService, RackPositionService, RackService, SkuService, UnitcodeService, ZoneService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ForkLiftJobService, StockInService } from '@gtpl/shared-services/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StockInAdapter } from '../stock-in/dto/stock-in.adapter';
import { StockIn } from '../stock-in/stock-in.entity';
import { StockAdapter } from './dto/stock.adapter';
import { StockController } from './stock.controller';
import { Stock } from './stock.entity';
import { StockService } from './stock.service';
import { StockView } from './stock-view.entity';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ScheduleModule } from '@nestjs/schedule';
import { ForkLiftJobsRepository } from '../fork-lift-jobs/dto/fork-lift-jobs.repository';
import { ForkLiftItemsRepository } from '../fork-lift-items/dto/fork-lift-items.repository';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { AllocatedSoEntity } from './allocated-sale-order.entity';
import { ProductionInventoryService } from '@gtpl/shared-services/production';
@Module({
  
  imports: [
    TypeOrmModule.forFeature([Stock,StockIn,StockView,AllocatedSoEntity]),
    ScheduleModule.forRoot()
  ],
  controllers: [StockController],
  providers: [StockService,ApplicationExceptionHandler,StockAdapter,SaleOrderService,PalletService,LocationsService, EndCustomersService, ProductService, SkuService, HLpercentagesService,RackPositionService,PackingMethodService, RackEndCustomerMapService,ForkLiftJobService,StockInService,StockInAdapter,RackService,ZoneService,GradeServices,WhatsAppNotificationService,ForkLiftJobsRepository,ForkLiftItemsRepository,WhatsappBroadCastService,UnitcodeService,ProductionInventoryService]
})
export class StockModule {}
